import { render, staticRenderFns } from "./knockout-standings.vue?vue&type=template&id=ad498ed2&scoped=true&"
import script from "./knockout-standings.vue?vue&type=script&lang=js&"
export * from "./knockout-standings.vue?vue&type=script&lang=js&"
import style0 from "./knockout-standings.vue?vue&type=style&index=0&id=ad498ed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad498ed2",
  null
  
)

export default component.exports